module.exports = __webpack_public_path__ + "img/bx_bxs-category.c6b435a7.svg";